import React from 'react'
import { subscribe } from 'react-contextual'
import { SearchFilter } from '../../../views/components'
// Imported off its own path, not the views/components barrel: the barrel and this module are in a
// require cycle, so a named import off it is still undefined while this file is evaluating.
import Header from '../../../views/components/molecules/Header/Header'
import PropertyIcon from '../../../views/components/atoms/Svgs/Property'
import PortfoliosProvider from '../PortfoliosProvider'
import LeaseFilterPills from './LeaseFilterPills/LeaseFilterPills'
import styles from './SearchFilter.module.scss'

const PropertiesSearchFilter = (props: any) => (
  <SearchFilter
    {...props}
    subFilters={
      <>
        <Header className={styles.heading} icon={<PropertyIcon />} text="Leases" />
        <LeaseFilterPills />
      </>
    }
  />
)

export default subscribe([PortfoliosProvider], ({ location, redirect, filters }: any) => ({
  pathname: location.pathname,
  redirect,
  filters,
}))(PropertiesSearchFilter)
